import React from 'react'
import { useDispatch } from 'hooks/use-redux'
import type { Playlist, PlaylistId } from 'types/playlist'
import type { Shortlist } from 'types/shortlist'
import type { Track } from 'types/track'
import { loadBatch } from '@disco/state-management/actions/PlaylistTrackActions'
import PlaylistSelectionDialog from 'components/modals/playlist-selection-dialog'
type Props = {
  onClose: (...args: Array<any>) => any
  onSubmit: (playlistIds: PlaylistId[]) => void
  track: Track
  shortlists: Shortlist[]
  type?: 'add' | 'copy'
  multi?: boolean
}

const AddToPlaylist = ({
  onClose,
  onSubmit,
  track,
  shortlists,
  type = 'add',
  multi = false,
}: Props): React.ReactNode => {
  const dispatch = useDispatch()

  const getOptions = async ({
    callback,
    playlists,
  }: {
    callback: (err: Error | null | undefined, result?: any) => void
    playlists: Playlist[]
  }) => {
    try {
      dispatch(loadBatch(playlists))
      const result = {
        options: playlists.map(r => {
          const disabled =
            (track.playlists || []).includes(r.playlist_id) ||
            shortlists
              .find(s => s.playlist_id === r.playlist_id)
              ?.items?.find(item => item.track.id === track.id)
          return {
            value: r.playlist_id,
            label: disabled ? `${r.name} (added)` : r.name,
            disabled,
          }
        }),
        complete: false,
      }
      callback(null, result)
    } catch (err) {
      callback(err)
    }
  }

  const caption = `${type === 'copy' ? 'Copy' : 'Add'} to playlist`
  return (
    <PlaylistSelectionDialog
      title={caption}
      submitButtonCaption={caption}
      getOptions={getOptions}
      onClose={onClose}
      onSubmit={onSubmit}
      multi={multi}
    />
  )
}

export default AddToPlaylist
